/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(2);

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	$(function () {
	    var $body = $('#js-letters-article-body');
	    if ($body.length < 1) {
	        return;
	    }
	    $body.find('a[target="_blank"]').each(function(){
	        var $this = $(this);
	        var text = $this.text();
	        $this.html('<span>'+ text + '</span>');
	    });
	});

/***/ },
/* 3 */
/***/ function(module, exports) {

	$(function () {
	    var $rightFixed = $('#js-right-fixed');
	    if ($rightFixed.length < 1 || window.UA.isSP === true) {
	        return;
	    }
	    $(window).on('imageloaded', function(){
	        var offsetTop = $rightFixed.offset().top + 50;
	        var offsetFooter = getOffetFooter();
	        if ($('.content-letters-detail-main').height() >  $rightFixed.height()) {
	            $(window).on('scroll', function () {
	                if($(window).width() < 781){
	                    $rightFixed.css({'position': 'static', 'top': 'auto'});
	                }else{
	                    side($rightFixed, offsetTop, offsetFooter);
	                }
	            });
	            $(window).on('resize', function () {
	                //left = getLeft();
	                offsetFooter = getOffetFooter();
	                $(window).trigger('scroll');
	            });
	        }
	    });
	    function getLeft() {
	        return $rightFixed.offset().left;
	    }
	
	    function getOffetFooter() {
	        return $('.l-footer').offset().top;
	    }
	
	    function side($elm, h, end) {
	        var scrollPos = $(window).scrollTop(),
	            endPos = end - $elm.height()-245;
	
	        //console.log(scrollPos, h, end, endPos, left);
	        if (scrollPos >= h - 50 && scrollPos <= endPos) {
	            $elm.css({'position': 'fixed', 'top': 0});
	        } else if (scrollPos < h) {
	            $elm.css({'position': 'absolute', 'top': 0});
	        } else if (scrollPos > endPos) {
	            $elm.css({'position': 'absolute', 'top': endPos-365});
	        }
	    }
	});

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** letters-detail.js
 **/